export const FILTER_TYPES = {
    BOOLEAN: 'BOOLEAN',
    GENDER: 'GENDER',
    GLOBAL_SEARCH: 'GLOBAL_SEARCH',
    SEARCH: 'SEARCH'
}